import { APP_HOST } from '@/app.config';
import AxiosClientService from '@/services/core/axios/axios';

class ClinicApi {
  constructor() {
    this.api = AxiosClientService.instance;
  }

  async addClinicToFavorite(clinicId) {
    const {
      data: { data }
    } = await this.api.post(
      `${APP_HOST}v2/clinic/add-favorite-clinic`,
      {},
      {
        params: {
          clinicId
        }
      }
    );

    return data;
  }

  async removeClinicFromFavorite(clinicId) {
    const {
      data: { data }
    } = await this.api.post(
      `${APP_HOST}v2/clinic/remove-favorite-clinic`,
      {},
      {
        params: {
          clinicId
        }
      }
    );

    return data;
  }
}

const clinicApi = new ClinicApi();
export default clinicApi;
